module.exports = __webpack_public_path__ + "static/background-lions-b05c937b4ce07ac03cca42c51989c182.svg";